import { Motif } from '../types/motifs'

export interface CoordinateData {
  id: number
  lat: number
  lng: number
}

// ObjRelatedPlaceTxt-like values look like "Torda (Torda-Aranyos vm. -> Magyarorszag -> ...)", we only want the city name
export const getCityName = (placeText?: string | null): string | undefined => {
  const city = placeText?.split('(')[0].trim()
  return city || undefined
}

export const parseCoordinates = (coordString: string): { lat: number; lng: number } | null => {
  if (!coordString || coordString.trim() === '') {
    return null
  }

  const parts = coordString.split(',').map(s => s.trim())
  if (parts.length !== 2) {
    return null
  }

  const lng = parseFloat(parts[0])
  const lat = parseFloat(parts[1])

  if (isNaN(lat) || isNaN(lng)) {
    return null
  }

  return { lat, lng }
}

export const getCoordinatesFromMotifs = (motifs: Motif[]): CoordinateData[] => {
  return motifs
    .map(motif => {
      const parsed = parseCoordinates(motif.coordinates)
      if (!parsed) return null

      return { id: motif.id, lat: parsed.lat, lng: parsed.lng }
    })
    .filter((item): item is CoordinateData => item !== null)
}
